<template>
  <v-container>
    <v-row v-if="siteId != null">
      <v-col cols="12" lg="10" offset-lg="1">
        <design-form :site-id="siteId" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import DesignForm from './forms/DesignForm'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    DesignForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'デザイン設定',
      siteId: null,
      tab: null
    }
  },
  mounted: function () {
    axios.get('/api/site_reference').then(
      ({ data }) => {
        this.siteId = data.data.attributes.id
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: `サイト情報の取得に失敗しました（${error.response.data.errors.toString()}）`
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  }
}
</script>

<style scoped></style>
